module.exports = __webpack_public_path__ + "static/media/usd.ffa445e5.svg";